import { render, staticRenderFns } from "./DbpyD_ReceiveList.vue?vue&type=template&id=27e18805"
import script from "./DbpyD_ReceiveList.vue?vue&type=script&lang=js"
export * from "./DbpyD_ReceiveList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports